/* SİMYAHANE — TEK script dosyası.
   sim-ortak her bölümde <script src> basıyor. Tarayıcı dosyayı bir kez
   indirir ama HER KOPYAYI ÇALIŞTIRIR; __SIM_BOOT ikinciyi susturur. */
(function () {
  if (window.__SIM_BOOT) return;
  window.__SIM_BOOT = 1;

  // Kuruş → "1.790" (yalnızca sayı, para birimi YOK).
  // Shopify para formatı admin'de {{amount_no_decimals_with_comma_separator}} ₺
  // olarak ayarlı; JS ile basılan her fiyat aynı görünmek zorunda.
  // Para birimi her zaman kendi <span class="cur">₺</span> etiketinde olmalı;
  // CSS .sim-fiyat .cur ona ayrı ağırlık/opaklık veriyor.
  function para(kurus) {
    var n = Math.round(Number(kurus) / 100);
    if (!isFinite(n)) return '';
    return n.toLocaleString('tr-TR');
  }

  // Kuruş → '1.790<span class="cur">₺</span>'
  // Bölüm JS'leri (Görev 7, 10 vb.) bu fonksiyonu kullanır;
  // aynı işi yapan yerel kopyalar yazılmaz.
  function paraHtml(kurus) {
    return para(kurus) + '<span class="cur">₺</span>';
  }

  // sim-fiyat.liquid'in JS ikizi — varyant değişince fiyat kutusunun
  // TAMAMI bununla yeniden kurulur. Kurallar snippet'le BİREBİR aynı:
  //  · görsel-gizli "Fiyat: " / "Eski fiyat: " etiketleri korunur
  //    (Görev 4 Y-3; önceden `innerHTML = paraHtml()` "Fiyat:"ı her sayfa
  //    yüklemesinde siliyordu — dal incelemesi madde 3)
  //  · çizili fiyat YALNIZ `eski > f` ise basılır, değilse HİÇ basılmaz
  //    (dal incelemesi madde 2: çizili fiyat güncellenmediği için
  //    indirimsiz varyanta geçince ilk varyantın "indirimi" ekranda
  //    kalıyor, olmayan bir indirim ilan ediliyordu)
  // f null/undefined ise boş döner (snippet'in `f == nil` dalıyla aynı).
  function fiyatHtml(f, eski) {
    if (f === null || f === undefined) return '';
    var h = '<span class="sim-fiyat"><span class="sim-gorsel-gizli">Fiyat: </span>' +
      paraHtml(f) + '</span>';
    if (eski !== null && eski !== undefined && Number(eski) > Number(f)) {
      h += '<s class="sim-fiyat sim-fiyat--eski"><span class="sim-gorsel-gizli">Eski fiyat: </span>' +
        paraHtml(Number(eski)) + '</s>';
    }
    return h;
  }

  // ── kaydırma konumu yalnız geri/ileride geri gelir — 2026-10-11 ──
  // Horizon (assets/scroll-container.js) ≥990 px'te sayfayı .page-wrapper
  // içinde kaydırır; ayrılırken (pagehide) konumu history.state.scrollTop'a
  // yazar ve HER pageshow'da geri yükler. Yenilemede ve aynı adrese yeniden
  // girişte de history.state korunduğu için ziyaretçi bir kez footer'a
  // indiyse site ondan sonra hep footer'da açılıyordu. Geri/ileri dışındaki
  // her yüklemede bu kayıt silinir; Horizon onu pageshow'da (load'dan sonra)
  // okur, bu dosya defer olduğu için ondan önce çalışır.
  try {
    var gezinme = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var gecmis = history.state;
    if (gezinme && gezinme.type !== 'back_forward' && gecmis && typeof gecmis === 'object' &&
        Object.prototype.hasOwnProperty.call(gecmis, 'scrollTop')) {
      var temiz = {};
      Object.keys(gecmis).forEach(function (k) { if (k !== 'scrollTop') temiz[k] = gecmis[k]; });
      history.replaceState(temiz, '');
    }
  } catch (e) { /* kaydırma geri yüklemesi kritik değil */ }

  // ── EasySell yönlendirme kancası — 2026-10-09 ─────────────────
  // EasySell sipariş oluşunca, teşekkür sayfasına yönlendirmeden hemen önce
  // window.es_hook_before_redirect(siparis)'i çağırır (await eder). Burada
  // yalnız siparişin satırları (varyant + adet) sessionStorage'a yazılır;
  // teşekkür sayfası (aşağıda) ürünleri buradan basar. Adres yalnız varyant
  // numaralarını taşır — "aynı satırda 2 adet" ile "iki ayrı satır"
  // adresten ayırt edilemez, adet bu yüzden buradan gelir.
  // Kanca ASLA hata fırlatmamalı: EasySell onu await ediyor, fırlatırsa
  // müşteri formda kalır, yönlendirme olmaz.
  var SIM_SIPARIS_ANAHTAR = 'sim-son-siparis';
  window.es_hook_before_redirect = function (siparis) {
    try {
      var kalemler = ((siparis && siparis.line_items) || []).map(function (k) {
        return { v: String(k.variant_id || ''), q: Number(k.quantity) || 0 };
      }).filter(function (k) { return /^\d+$/.test(k.v) && k.q > 0; });
      sessionStorage.setItem(SIM_SIPARIS_ANAHTAR, JSON.stringify({
        no: String((siparis && siparis.order_number) || ''),
        kalemler: kalemler
      }));
    } catch (e) { /* yönlendirmeyi hiçbir koşulda engelleme */ }
  };

  // ── mobil menü ────────────────────────────────────────────────
  // B7 (Görev 7 inceleme): bu blok ve altındaki hero bloğu KENDİ
  // try/catch'i içinde — önceden tüm kurulum kodu TEK bir üst kapsamda
  // sırayla çalışıyordu, biri (ör. burası) istisna atarsa ondan sonraki
  // HİÇBİR kod (ürün sayfası sepet kurulumu dahil) çalışmıyordu; "Sepete
  // Ekle" görünürdü ama tıklanınca sessizce hiçbir şey olmazdı. Şimdi her
  // özellik izole: birinin hatası diğerlerini engellemez.
  try {
  var drawer = document.querySelector('[data-sim-drawer]');
  // hidden=true'ya geçiren zamanlayıcı burada saklanır. Saklanmazsa hızlı
  // kapat→aç'ta eski zamanlayıcı 240ms sonra hâlâ ateşleyip yeni açılmış
  // drawer'ı gizliyordu; sim-kilit ise açılışta eklendiği için <html>
  // üzerinde takılı kalıyordu (Görev 2 inceleme Bulgu 2).
  var drawerKapatmaZamanlayici = null;
  // Açılmadan önce odakta olan eleman — kapanınca oraya geri dönülür.
  var drawerOncekiOdak = null;

  function drawerOdaklanabilirler() {
    return drawer.querySelectorAll('a[href], button:not([disabled]), summary');
  }

  function drawerAc(ac) {
    if (!drawer) return;
    clearTimeout(drawerKapatmaZamanlayici);
    if (ac) {
      drawerOncekiOdak = document.activeElement;
      drawer.hidden = false;
    }
    // hidden kaldırıldıktan SONRA sınıf eklenmeli, yoksa transform
    // geçişi ilk karede atlanır ve panel ansızın belirir.
    requestAnimationFrame(function () {
      drawer.classList.toggle('sim-drawer--acik', ac);
      if (ac) {
        // aria-modal="true" ekran okuyucuya diyalog dışının gizlendiğini
        // söylüyor; odak da diyalogun İÇİNE taşınmazsa kullanıcı gizli bir
        // ağaçta kalır (Görev 2 inceleme Bulgu 5).
        var kapaDugme = drawer.querySelector('[data-sim-drawer-kapa][type="button"]');
        if (kapaDugme) kapaDugme.focus();
      }
    });
    if (!ac) {
      drawerKapatmaZamanlayici = setTimeout(function () {
        drawer.hidden = true;
      }, 240);
      if (drawerOncekiOdak && typeof drawerOncekiOdak.focus === 'function') {
        drawerOncekiOdak.focus();
      }
      drawerOncekiOdak = null;
    }
    document.documentElement.classList.toggle('sim-kilit', ac);
    var d = document.querySelector('[data-sim-drawer-ac]');
    if (d) d.setAttribute('aria-expanded', String(ac));
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sim-drawer-ac]')) { drawerAc(true); }
    else if (e.target.closest('[data-sim-drawer-kapa]')) { drawerAc(false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { drawerAc(false); return; }
    // Panel açıkken Tab/Shift+Tab odağı panel İÇİNDE çevirir (odak tuzağı);
    // yoksa Tab, perdenin arkasındaki logo/sepet bağlantılarına kaçıyordu.
    if (e.key === 'Tab' && drawer && drawer.classList.contains('sim-drawer--acik')) {
      var el = drawerOdaklanabilirler();
      if (!el.length) return;
      var ilk = el[0], son = el[el.length - 1];
      if (e.shiftKey && document.activeElement === ilk) {
        e.preventDefault(); son.focus();
      } else if (!e.shiftKey && document.activeElement === son) {
        e.preventDefault(); ilk.focus();
      }
    }
  });
  } catch (e) {
    if (window.console && console.error) console.error('SİM drawer hatası:', e);
  }

  // ── mega menü (masaüstü) — katalog modeli 2026-10-07 ────────────
  // Düğme paneli açar/kapar; aynı anda tek panel açık. Escape kapatır ve odağı
  // düğmeye geri verir; panel dışına tıklamak kapatır. JS yoksa panel kapalı
  // kalır ama mobil çekmecedeki <details> akordeonu JS'siz çalışır.
  try {
    var megaAcik = null;
    var megaKapat = function (odakGeri) {
      if (!megaAcik) return;
      var dugme = megaAcik.querySelector('[data-sim-mega-ac]');
      megaAcik.querySelector('[data-sim-mega-panel]').hidden = true;
      dugme.setAttribute('aria-expanded', 'false');
      if (odakGeri) dugme.focus();
      megaAcik = null;
    };
    document.addEventListener('click', function (e) {
      var dugme = e.target.closest('[data-sim-mega-ac]');
      if (dugme) {
        var grup = dugme.closest('[data-sim-mega]');
        var ayniGrup = megaAcik === grup;
        megaKapat(false);
        if (!ayniGrup) {
          grup.querySelector('[data-sim-mega-panel]').hidden = false;
          dugme.setAttribute('aria-expanded', 'true');
          megaAcik = grup;
        }
        return;
      }
      if (megaAcik && !e.target.closest('[data-sim-mega]')) megaKapat(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') megaKapat(true);
    });
  } catch (e) {
    if (window.console && console.error) console.error('SİM mega menü hatası:', e);
  }

  // ── koleksiyon süzgeci — katalog modeli 2026-10-07 ──────────────
  // Değişen alan formu kendiliğinden gönderir; JS yoksa "Uygula" düğmesi var.
  // Boş fiyat kutuları gönderilmez (URL'de "filter.v.price.gte=" kalmasın).
  try {
    document.addEventListener('change', function (e) {
      var alan = e.target.closest('[data-sim-suzgec-oto]');
      if (!alan || !alan.form) return;
      if (typeof alan.form.requestSubmit === 'function') alan.form.requestSubmit();
      else alan.form.submit();
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sim-suzgec]');
      if (!form) return;
      Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (g) {
        if (g.value === '') g.disabled = true;
      });
    }, true);
  } catch (e) {
    if (window.console && console.error) console.error('SİM süzgeç hatası:', e);
  }

  // ── kampanya sayacı — vitrin 2026-10-08 (spec kural 1) ─────────
  // data-bitis = bitiş anı (Unix saniye; Liquid mağaza alanından basar).
  // Saniyede bir kalan süre yazılır; süre dolunca sayaç GİZLENİR ve durur —
  // sıfırlanmaz, yeniden başlamaz. Önbellekten gelen bayat sayfada süre zaten
  // dolmuşsa ilk çalıştırmada gizlenir.
  try {
    document.querySelectorAll('[data-sim-sayac]').forEach(function (el) {
      var bitis = parseInt(el.getAttribute('data-bitis'), 10) * 1000;
      if (!isFinite(bitis)) { el.hidden = true; return; }
      var iki = function (n) { return (n < 10 ? '0' : '') + n; };
      var yaz = function (ad, n) {
        var a = el.querySelector('[data-sim-sayac-' + ad + ']');
        if (a) a.textContent = iki(n);
      };
      var zaman = null;
      var guncelle = function () {
        var kalan = Math.floor((bitis - Date.now()) / 1000);
        if (kalan <= 0) {
          el.hidden = true;
          if (zaman) clearInterval(zaman);
          return;
        }
        yaz('gun', Math.floor(kalan / 86400));
        yaz('saat', Math.floor(kalan % 86400 / 3600));
        yaz('dakika', Math.floor(kalan % 3600 / 60));
        yaz('saniye', kalan % 60);
      };
      guncelle();
      if (!el.hidden) zaman = setInterval(guncelle, 1000);
    });
  } catch (e) {
    if (window.console && console.error) console.error('SİM sayaç hatası:', e);
  }

  // ── görselli yorumlar: "Daha fazla yorum" — vitrin 2026-10-08 ──
  // Sunucu bütün yorumları basar (JS yoksa hepsi görünür). Burada ilk 8'den
  // sonrakiler gizlenir, düğme açılır; basınca hepsi görünür, odak 9. kartta.
  try {
    document.querySelectorAll('[data-sim-yorumlar]').forEach(function (kok) {
      var kartlar = kok.querySelectorAll('[data-sim-yorum]');
      var dugme = kok.querySelector('[data-sim-yorum-daha]');
      if (!dugme || kartlar.length <= 8) return;
      for (var i = 8; i < kartlar.length; i++) kartlar[i].hidden = true;
      dugme.hidden = false;
      dugme.addEventListener('click', function () {
        for (var n = 8; n < kartlar.length; n++) kartlar[n].hidden = false;
        dugme.hidden = true;
        kartlar[8].setAttribute('tabindex', '-1');
        kartlar[8].focus();
      });
    });
  } catch (e) {
    if (window.console && console.error) console.error('SİM yorum hatası:', e);
  }

  // ── teşekkür sayfası — 2026-10-09 (sections/sim-tesekkur.liquid) ──
  // Adres: ?no=<sipariş no>&tutar=<biçimli toplam>&v=<varyant no'ları>.
  // Hepsi yalnız textContent / DOM düğümüyle basılır (innerHTML YOK —
  // adres herkesin yazabileceği bir girdi). Biçimi tutmayan değer yok
  // sayılır, satırı gizli kalır.
  // Ürünler: önce kancanın yazdığı sipariş (numara eşleşirse), yoksa `v`.
  // Her varyant ürününe çözülür: /variants/<id> ürün sayfasına yönlendirir
  // (handle oradan), görsel ve ad /products/<handle>.js'ten. Çözülemeyen
  // satır sessizce atlanır; hiçbiri çözülmezse liste gizli kalır.
  function tesekkurUrunBilgisi(k) {
    return fetch('/variants/' + k.v, { method: 'HEAD', credentials: 'same-origin' })
      .then(function (r) {
        var m = /\/products\/([^/?#]+)/.exec(r.url || '');
        if (!m) throw new Error('varyant çözülemedi');
        return fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('ürün ' + r.status);
        return r.json();
      })
      .then(function (p) {
        var vr = (p.variants || []).filter(function (x) { return String(x.id) === k.v; })[0] || {};
        return {
          ad: p.title || '',
          alt: vr.public_title || '',
          gorsel: (vr.featured_image && vr.featured_image.src) || p.featured_image || ''
        };
      })
      .catch(function () { return null; });
  }
  function tesekkurUrunSatiri(b, adet) {
    var li = document.createElement('li');
    li.className = 'sim-tesekkur__urun';
    if (b.gorsel) {
      var src = b.gorsel.indexOf('//') === 0 ? 'https:' + b.gorsel : b.gorsel;
      var ek = src.indexOf('?') === -1 ? '?' : '&';
      var img = document.createElement('img');
      img.className = 'sim-tesekkur__urun-g';
      img.alt = '';
      img.width = 96;
      img.height = 96;
      img.decoding = 'async';
      img.src = src + ek + 'width=200';
      img.srcset = src + ek + 'width=200 1x, ' + src + ek + 'width=400 2x';
      li.appendChild(img);
    }
    var bilgi = document.createElement('div');
    bilgi.className = 'sim-tesekkur__urun-bilgi';
    var ad = document.createElement('p');
    ad.className = 'sim-tesekkur__urun-ad';
    ad.textContent = b.ad;
    bilgi.appendChild(ad);
    if (b.alt) {
      var alt = document.createElement('p');
      alt.className = 'sim-tesekkur__urun-alt';
      alt.textContent = b.alt;
      bilgi.appendChild(alt);
    }
    li.appendChild(bilgi);
    if (adet > 0) {
      var a = document.createElement('span');
      a.className = 'sim-tesekkur__urun-adet';
      a.textContent = adet + ' adet';
      li.appendChild(a);
    }
    return li;
  }
  try {
    document.querySelectorAll('[data-sim-tesekkur]').forEach(function (kok) {
      var q = new URLSearchParams(window.location.search);
      var ozet = kok.querySelector('[data-sim-tesekkur-ozet]');
      var satirAc = function (ad, dugum) {
        var s = kok.querySelector('[data-sim-tesekkur-satir="' + ad + '"]');
        if (!s) return;
        s.querySelector('[data-sim-tesekkur-deger]').appendChild(dugum);
        s.hidden = false;
        if (ozet) ozet.hidden = false;
      };
      var no = (q.get('no') || '').trim().replace(/^#/, '');
      if (/^\d{1,10}$/.test(no)) satirAc('no', document.createTextNode('#' + no));
      var t = /^([\d.,]{1,12})[\s ]*(?:₺|TL)?$/.exec((q.get('tutar') || '').trim());
      if (t) {
        var f = document.createElement('span');
        f.className = 'sim-fiyat';
        f.appendChild(document.createTextNode(t[1]));
        var cur = document.createElement('span');
        cur.className = 'cur';
        cur.textContent = '₺';
        f.appendChild(cur);
        satirAc('tutar', f);
      }

      var liste = kok.querySelector('[data-sim-tesekkur-urunler]');
      if (!liste) return;
      var kalemler = null;
      try {
        var kayit = JSON.parse(sessionStorage.getItem(SIM_SIPARIS_ANAHTAR) || 'null');
        if (kayit && Array.isArray(kayit.kalemler) && kayit.kalemler.length &&
            (!no || kayit.no === no)) kalemler = kayit.kalemler;
      } catch (e) { kalemler = null; }
      if (!kalemler) {
        // Adres yedeği: adet bilinmiyor (0 → basılmaz).
        kalemler = ((q.get('v') || '').match(/\d{5,20}/g) || [])
          .map(function (v) { return { v: v, q: 0 }; });
      }
      var birlesik = [];
      var gorulen = {};
      kalemler.forEach(function (k) {
        if (gorulen[k.v]) { gorulen[k.v].q += k.q; return; }
        gorulen[k.v] = { v: k.v, q: k.q };
        birlesik.push(gorulen[k.v]);
      });
      birlesik = birlesik.slice(0, 10);
      if (!birlesik.length) return;
      Promise.all(birlesik.map(tesekkurUrunBilgisi)).then(function (bilgiler) {
        bilgiler.forEach(function (b, i) {
          if (b && b.ad) liste.appendChild(tesekkurUrunSatiri(b, birlesik[i].q));
        });
        if (liste.children.length) liste.hidden = false;
      });
    });
  } catch (e) {
    if (window.console && console.error) console.error('SİM teşekkür hatası:', e);
  }

  // ── indirim penceresi — 2026-10-11 (sections/sim-indirim-penceresi.liquid) ──
  // E-posta karşılığı indirim kodu. Kurallar:
  //  · data-gecikme saniye sonra açılır. Kapatılırsa 7 gün, e-posta
  //    bırakılırsa bir daha hiç açılmaz (localStorage 'sim-ip').
  //  · localStorage okunamıyorsa kendiliğinden HİÇ açılmaz: her sayfada
  //    yeniden açılan pencere, hiç açılmayandan kötü.
  //  · Kapıda ödeme formu (EasySell) açıksa ya da ziyaretçi sipariş/sepet
  //    düğmesine dokunduysa bu sayfa görüntülemesinde açılmaz; satın alan
  //    kişinin önüne pencere çıkmaz. Mobil menü açıksa ertelenir.
  //  · Gönderim doğal form gönderimidir (neden: liquid yorumu). Dönüşte
  //    data-sim-ip-durum="tamam" → kod adımıyla hemen açılır, adres temizlenir.
  try {
    var ip = document.querySelector('[data-sim-indirim-penceresi]');
    if (ip) (function () {
      var ANAHTAR = 'sim-ip';
      var HAFTA = 7 * 864e5;
      var kutu = ip.querySelector('[role="dialog"]');
      var durumEl = ip.querySelector('[data-sim-ip-durum]');
      var durum = durumEl ? durumEl.getAttribute('data-sim-ip-durum') : '';
      var kayit = null;
      var depoVar = true;
      try { kayit = JSON.parse(localStorage.getItem(ANAHTAR) || 'null'); }
      catch (e) { depoVar = false; }
      var acik = false, iptal = false, oncekiOdak = null, kapatZ = null;

      function yaz(k) {
        kayit = { k: k, t: Date.now() };
        try { localStorage.setItem(ANAHTAR, JSON.stringify(kayit)); } catch (e) { /* engelli */ }
      }
      function odaklanabilirler() {
        return Array.prototype.filter.call(
          kutu.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'),
          function (el) { return el.getClientRects().length > 0; });
      }
      function ac(odak) {
        if (acik) return;
        acik = true;
        clearTimeout(kapatZ);
        oncekiOdak = document.activeElement;
        ip.hidden = false;
        document.documentElement.classList.add('sim-kilit');
        // hidden kalktıktan SONRA sınıf eklenir, yoksa geçiş ilk karede atlanır.
        requestAnimationFrame(function () {
          ip.classList.add('sim-ip--acik');
          // Odak diyaloğun kendisine: e-posta alanına verilirse mobilde
          // klavye kendiliğinden açılır. Hata dönüşünde alana verilir.
          (odak || kutu).focus({ preventScroll: true });
        });
      }
      function kapat() {
        if (!acik) return;
        acik = false;
        ip.classList.remove('sim-ip--acik');
        document.documentElement.classList.remove('sim-kilit');
        kapatZ = setTimeout(function () { ip.hidden = true; }, 200);
        if (!kayit || kayit.k !== 'kayit') yaz('kapandi');
        if (oncekiOdak && typeof oncekiOdak.focus === 'function') {
          oncekiOdak.focus({ preventScroll: true });
        }
        oncekiOdak = null;
      }
      function siparisFormuAcik() {
        var m = document.getElementById('easysell-modal');
        return !!(m && m.getClientRects().length > 0);
      }
      function dene(kalan) {
        if (iptal || acik) return;
        if (siparisFormuAcik()) { iptal = true; return; }
        // Çerez bandı yanıtlanmadan ikinci bir pencere çıkmaz; band kapanınca
        // en geç 2,5 sn içinde açılır (sayaç düşmez, band beklenir).
        var cerez = document.querySelector('[data-sim-cerez]');
        if (cerez && !cerez.hidden) {
          setTimeout(function () { dene(kalan); }, 2500);
          return;
        }
        if (document.documentElement.classList.contains('sim-kilit')) {
          if (kalan > 0) setTimeout(function () { dene(kalan - 1); }, 4000);
          return;
        }
        ac();
      }
      function kopyala(dugme) {
        var kodEl = ip.querySelector('[data-sim-ip-kod]');
        if (!kodEl) return;
        var kod = kodEl.textContent.trim();
        function sec() {
          var r = document.createRange();
          r.selectNodeContents(kodEl);
          var s = window.getSelection();
          s.removeAllRanges();
          s.addRange(r);
        }
        function eskiYol() {
          try { sec(); return document.execCommand('copy'); } catch (e) { return false; }
        }
        function bitti(oldu) {
          // Kopyalanamadıysa kod seçili bırakılır; ziyaretçi elle kopyalar.
          if (!oldu) { try { sec(); } catch (e) { /* yok */ } return; }
          dugme.textContent = 'Kopyalandı';
          setTimeout(function () { dugme.textContent = 'Kopyala'; }, 2000);
        }
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(kod).then(function () { bitti(true); },
            function () { bitti(eskiYol()); });
        } else {
          bitti(eskiYol());
        }
      }

      ip.addEventListener('click', function (e) {
        if (e.target.closest('[data-sim-ip-kapat]')) { kapat(); return; }
        var k = e.target.closest('[data-sim-ip-kopyala]');
        if (k) kopyala(k);
      });
      document.addEventListener('keydown', function (e) {
        if (!acik) return;
        if (e.key === 'Escape') { kapat(); return; }
        if (e.key !== 'Tab') return;
        var el = odaklanabilirler();
        if (!el.length) return;
        var ilk = el[0], son = el[el.length - 1], su = document.activeElement;
        if (e.shiftKey && (su === ilk || su === kutu)) { e.preventDefault(); son.focus(); }
        else if (!e.shiftKey && su === son) { e.preventDefault(); ilk.focus(); }
      });
      // Satın alma niyeti: sipariş formu düğmesi, yapışkan düğme, sepete ekle.
      document.addEventListener('click', function (e) {
        if (!acik && e.target.closest('[class*="es-popup-button"], .es-sticky-btn, .sim-atc, #easysell-modal')) {
          iptal = true;
        }
      }, true);

      if (durum === 'tamam') {
        yaz('kayit');
        try {
          var u = new URL(location.href);
          u.searchParams.delete('customer_posted');
          u.hash = '';
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* eski tarayıcı: adres olduğu gibi kalır */ }
        ac();
      } else if (durum === 'hata' && location.hash === '#sim-ip') {
        ac(ip.querySelector('input[type="email"]'));
      } else if (depoVar && !(kayit && (kayit.k === 'kayit' ||
                 (kayit.k === 'kapandi' && Date.now() - kayit.t < HAFTA)))) {
        var sn = parseInt(ip.getAttribute('data-gecikme'), 10);
        if (!(sn >= 1)) sn = 6;
        setTimeout(function () { dene(2); }, sn * 1000);
      }
    })();
  } catch (e) {
    if (window.console && console.error) console.error('SİM indirim penceresi hatası:', e);
  }

  // ── kartla öde — 2026-10-12 (sim-urun-satinalma, ayar kart_dugmesi) ──
  // Tıklama anındaki varyant ve adetle /cart/<varyant>:<adet> sepet
  // bağlantısına gider (Shopify sepeti kurar, ödeme sayfasını açar). Paket
  // seçicide adet seçili radyodan, adet kutusunda girdiden okunur. Değer
  // bozuksa düğmenin kendi href'ine bırakılır.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sim-kartla-ode]');
    if (!a) return;
    try {
      var kok = a.closest('[data-sim-urun]');
      var form = kok && kok.querySelector('[data-sim-atc-form]');
      if (!form) return;
      var id = String((form.querySelector('[name="id"]') || {}).value || '');
      var q = form.querySelector('input[name="quantity"]:checked') ||
              form.querySelector('input[name="quantity"]:not([type="radio"])');
      var adet = parseInt(q ? q.value : '1', 10);
      if (!/^\d+$/.test(id) || !(adet >= 1 && adet <= 99)) return;
      e.preventDefault();
      location.href = '/cart/' + id + ':' + adet;
    } catch (hata) { /* düğmenin kendi bağlantısı çalışır */ }
  });

  // ── çerez bandı — 2026-10-11 (sections/sim-cerez.liquid) ──────────
  // Pikselin kuyruğu ve yükleyicisi bölümdeki satır içi betikte (EasySell'den
  // önce çalışması gerektiği için orada). Burada yalnız band arayüzü:
  //  · tercih yoksa band açılır;
  //  · Kabul → fbevents.js yüklenir (kuyruktaki olaylar o an gider);
  //  · Reddet → yüklenmez; bu sayfada zaten yüklendiyse consent revoke;
  //  · iki durumda da Shopify'ın müşteri gizliliği API'sine aynı karar
  //    bildirilir (Shopify'ın kendi ölçümü ve uygulama pikselleri uyar);
  //  · footer'daki "Çerez tercihleri" bandı yeniden açar.
  try {
    var cerezBant = document.querySelector('[data-sim-cerez]');
    document.querySelectorAll('[data-sim-cerez-ac]').forEach(function (d) {
      d.hidden = !cerezBant;
    });
    if (cerezBant) (function () {
      // evet: true (Kabul) / false (Reddet) / null (henüz seçim yok).
      // Seçim yokken Shopify'a "pazarlama izni yok" bildirilir (ölçüm ve tercih
      // açık): Türkiye'de Shopify varsayılanı "izin var" sayıyor, yoksa Müşteri
      // etkinliklerindeki Meta pikseli (kartlı satın alma, 2026-10-12) bandı
      // yanıtlamayan ziyaretçide de çalışırdı. Kabul edince açılır.
      function shopifyRiza(evet) {
        try {
          var S = window.Shopify;
          if (!S || !S.loadFeatures) return;
          var r = evet === null
            ? { analytics: true, marketing: false, preferences: true, sale_of_data: false }
            : { analytics: evet, marketing: evet, preferences: evet, sale_of_data: evet };
          S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (hata) {
            if (hata || !S.customerPrivacy) return;
            S.customerPrivacy.setTrackingConsent(r, function () {});
          });
        } catch (e) { /* Shopify API yoksa yalnız Meta kararı geçerli */ }
      }
      function sec(k) {
        try { localStorage.setItem('sim-cerez', JSON.stringify({ k: k, t: Date.now() })); }
        catch (e) { /* depolama kapalı: karar bu sayfa için geçerli */ }
        window.SIM_CEREZ = k;
        if (k === 'kabul') {
          if (window.fbq) window.fbq('consent', 'grant');
          if (window.SIM_FB_YUKLE) window.SIM_FB_YUKLE();
        } else if (window.__SIM_FB_YUKLENDI && window.fbq) {
          window.fbq('consent', 'revoke');
        }
        shopifyRiza(k === 'kabul');
        cerezBant.hidden = true;
      }
      if (window.SIM_CEREZ !== 'kabul' && window.SIM_CEREZ !== 'red') {
        cerezBant.hidden = false;
        shopifyRiza(null);
      }
      cerezBant.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sim-cerez-sec]');
        if (b) sec(b.getAttribute('data-sim-cerez-sec'));
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-sim-cerez-ac]')) return;
        cerezBant.hidden = false;
        var ilk = cerezBant.querySelector('[data-sim-cerez-sec]');
        if (ilk) ilk.focus({ preventScroll: true });
      });
    })();
  } catch (e) {
    if (window.console && console.error) console.error('SİM çerez bandı hatası:', e);
  }

  // ── koleksiyon süzgeci: Dawn yatay çubuk — vitrin 2026-10-08 ──────
  // ≥750 px'te dış panel ("Süzgeç ve sırala" çekmecesi) hep açık tutulur,
  // süzgeçler başlık başına açılır kutu olur: aynı anda tek kutu açık;
  // dışarı tıklamak ve Escape kapatır. JS'li sayfada masaüstünde genel
  // "Uygula" gizlenir (liste ve sıralama kendiliğinden gönderilir, fiyat
  // kutusunun kendi Uygula düğmesi var).
  try {
    var suzgecGenis = window.matchMedia('(min-width: 750px)');
    document.querySelectorAll('[data-sim-suzgec]').forEach(function (form) {
      form.classList.add('sim-suzgec--js');
      var panel = form.querySelector('.sim-suzgec__panel');
      // İlk yüklemede YALNIZ açar — sayfa <750 px'te açılmışsa (aktif süzgeç,
      // Liquid'in bastığı `open`) burada kapatılmaz. `change` olayı ise
      // gerçek bir geçiş anıdır (kullanıcı pencereyi/aygıtı döndürüyor);
      // C6 (son dal incelemesi) — orada simetrik davranılır: ≥750'ye
      // geçince açar, <750'ye geçince kapatır (önceden yalnız açıyordu,
      // geri geçişte çekmece yanlışlıkla açık kalıyordu).
      var panelAc = function () { if (panel && suzgecGenis.matches) panel.open = true; };
      panelAc();
      if (suzgecGenis.addEventListener) {
        suzgecGenis.addEventListener('change', function (e) {
          if (panel) panel.open = e.matches;
        });
      }
      form.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!suzgecGenis.matches || !d.open || !d.matches('[data-sim-suzgec-acilir]')) return;
        form.querySelectorAll('[data-sim-suzgec-acilir][open]').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      }, true);
    });
    document.addEventListener('click', function (e) {
      if (!suzgecGenis.matches) return;
      document.querySelectorAll('[data-sim-suzgec-acilir][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-sim-suzgec-acilir][open]').forEach(function (d) {
        d.open = false;
        d.querySelector('summary').focus();
      });
    });
  } catch (e) {
    if (window.console && console.error) console.error('SİM süzgeç çubuğu hatası:', e);
  }

  // ── hero: dikey video duraklat/oynat + hareketi azalt ───────────
  // sim-hero.liquid video'yu autoplay+loop+controls:false ile basıyor —
  // durdurma yolu olmadan bu, WCAG 2.2.2 (Pause/Stop/Hide) ihlali olurdu
  // (Görev 3 inceleme Bulgu 2). İki şey çözülüyor: (a) OS'te "hareketi
  // azalt" açıksa video hiç oynamadan duruyor, video_tag zaten poster
  // bastığı için ilk kare durağan görsel gibi kalıyor, düzen bozulmuyor;
  // (b) her durumda klavyeyle erişilebilir bir duraklat/oynat düğmesi var.
  try {
  var heroVideo = document.querySelector('.sim-hero__medya video');
  var heroDugme = document.querySelector('[data-sim-hero-video-kontrol]');
  if (heroVideo) {
    var heroIkon = heroDugme ? heroDugme.querySelector('span') : null;
    var heroDurumGuncelle = function (oynuyor) {
      if (!heroDugme) return;
      heroDugme.setAttribute('aria-label', oynuyor ? 'Videoyu duraklat' : 'Videoyu oynat');
      if (heroIkon) heroIkon.textContent = oynuyor ? '❙❙' : '►';
    };
    var azaltilmisHareket = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (azaltilmisHareket) {
      heroVideo.pause();
      heroDurumGuncelle(false);
    } else {
      heroDurumGuncelle(!heroVideo.paused);
    }
    if (heroDugme) {
      heroDugme.addEventListener('click', function () {
        if (heroVideo.paused) { heroVideo.play(); } else { heroVideo.pause(); }
        heroDurumGuncelle(!heroVideo.paused);
      });
      heroVideo.addEventListener('play', function () { heroDurumGuncelle(true); });
      heroVideo.addEventListener('pause', function () { heroDurumGuncelle(false); });
    }
  }
  } catch (e) {
    if (window.console && console.error) console.error('SİM hero video hatası:', e);
  }

  // ── sepet sayacı ──────────────────────────────────────────────
  // Sepete ekleyen her yer (Görev 7 ürün sayfası, Görev 9 set tamamla)
  // sayfayı yenilemeden bunu çağırır.
  function sepetSayaciniGuncelle(adet) {
    document.querySelectorAll('[data-sim-sepet-sayi]').forEach(function (el) {
      el.textContent = adet;
      el.classList.toggle('sim-sepet__sayi--bos', !adet);
    });
    // Görsel-gizli, aria-live="polite" metin — sepete ekleme sayfa
    // yenilenmeden olduğunda ekran okuyucu kullanıcısı için TEK geri
    // bildirim kanalı budur (Görev 2 inceleme Bulgu 4).
    document.querySelectorAll('[data-sim-sepet-metin]').forEach(function (el) {
      el.textContent = 'Sepet, ' + adet + ' ürün';
    });
  }

  // ── sepet sayfası: miktar değiştirme + satır silme ──────────────
  // (Görev 10 + düzeltmesi). Her satırın KENDİ <form>'u var, action'ı
  // routes.cart_change_url (id + quantity POST eder) — JS hiç çalışmazsa
  // tarayıcı formu NORMAL gönderir, Shopify günceller ve sepete geri
  // yönlendirir (karar 2). JS aynı formu fetch ile (action + '.js',
  // Shopify AJAX Sepet API'si aynı alanları kabul eder) gönderir.
  //
  // KÖK: `[data-sim-sepet-sayfa]`. `[data-sim-sepet]` HEADER'daki sepet
  // bağlantısıdır — önceden burada o seçiliyordu, dinleyiciler header'a
  // bağlanıyor, +/− hiç istek göndermiyordu (Görev 10 inceleme K2).
  //
  // SIRALAMA (Y1): bütün istekler TEK bir Promise zincirinden (kuyruk)
  // sırayla geçer; +/− tıkları 350 ms birikir, satır başına yalnız SON
  // değer gönderilir. Sayfa yalnız kuyruk tamamen boşalınca (uçuşta istek
  // ve bekleyen zamanlayıcı yokken) yenilenir; yenilemeden önce sayaç en
  // son yanıtla güncellenir. Önceden her tık ayrı paralel istekti, sayfa
  // İLK yanıtla yenileniyordu: ekranda 2, gerçek sepette 4.
  //
  // ELLE YAZILAN MİKTAR (K3): sayı kutusunun `change` olayı (iOS'ta
  // "Bitti"/odak kaybı) isteği 300 ms sonra kuyruğa koyar. "Siparişi
  // Tamamla" basıldığında gönderilmemiş bir değer ya da uçuşta istek
  // varsa checkout BEKLETİLİR: önce hepsi gönderilir, sonra checkout.
  //
  // HATALAR (Y2): sunucu yanıt verip reddettiyse (4xx/5xx) Shopify'ın
  // `description`/`message` metni satırın role="alert" bölgesine yazılır,
  // kutu son onaylı değere döner, checkout iptal edilir — tam sayfa POST
  // YAPILMAZ (başarısız olduğu bilinen isteği tekrar göndermek anlamsız).
  // Yalnız AĞ hatasında (fetch reddedildi) formun kendi POST'una düşülür.
  //
  // ODAK (inceleme O2 / düşük bulgu): yenilemeden önce hedef sessionStorage'a
  // yazılır; yüklemede miktar değişen satırın aynı kontrolüne, silmede
  // bir sonraki satırın ürün adına (son satırsa sepet başlığına) odaklanır
  // ve görsel-gizli durum bölgesi yeni ara toplamı TEK SEFER duyurur.
  //
  // Miktar/silme sonrası sayfa BİLEREK yenilenir: ara toplam, satır
  // indirimi ve otomatik indirim Shopify tarafında hesaplanıyor; JS'in
  // bunları yeniden hesaplaması gerçekle ayrışma riski taşır.
  try {
  var sepetKok = document.querySelector('[data-sim-sepet-sayfa]');
  if (sepetKok) {
    var SEPET_ODAK_ANAHTARI = 'sim-sepet-odak';
    var sepetKuyruk = Promise.resolve();
    var sepetUcusta = 0;               // kuyruğa girmiş, bitmemiş istek
    var sepetZaman = new Map();        // adet formu → bekleyen zamanlayıcı
    var sepetOdemeBekliyor = false;
    var sepetDegisti = false;          // en az bir istek başarılı oldu
    var sepetAyriliyor = false;        // yerel POST'a düşüldü, sayfa gidiyor
    var sepetSonYanit = null;
    var sepetSonOdak = null;
    var sepetHatalar = [];             // {anahtar, metin}
    var odemeForm = sepetKok.querySelector('[data-sim-odeme-form]');

    var satirAnahtari = function (form) {
      var li = form.closest('[data-anahtar]');
      return li ? li.getAttribute('data-anahtar') : null;
    };

    // Kutudaki değeri 0..max tam sayıya indirger (D4: +/− ve elle yazım
    // tarayıcının min/step doğrulamasını atlıyordu — "2.5" + "+" → 3.5,
    // "-5" + "−" → satır silinirdi). Boş, anlamsız ya da NEGATİF giriş →
    // null: kutu son gönderilen değere döner, hiçbir şey gönderilmez
    // (satırı yalnız bilinçli 0 ya da "Kaldır" siler).
    var girisDegeri = function (giris) {
      if (giris.value.trim() === '') return null;
      var n = Math.floor(Number(giris.value));
      if (!isFinite(n) || n < 0) return null;
      var ust = giris.hasAttribute('max') ? Math.floor(Number(giris.getAttribute('max'))) : Infinity;
      if (!isFinite(ust) || ust < 0) ust = Infinity;
      return Math.min(Math.max(0, n), ust);
    };

    var satirHataYaz = function (form, metin) {
      var li = form.closest('[data-anahtar]');
      var el = li && li.querySelector('[data-sim-satir-hata]');
      if (el) el.textContent = metin || '';
    };

    // Satır silinecekse odak: bir sonraki satır, yoksa önceki, o da yoksa
    // (sepet boşalacak) başlık.
    var silOdagi = function (li) {
      var komsu = li && (li.nextElementSibling || li.previousElementSibling);
      return komsu ? { tur: 'satir', anahtar: komsu.getAttribute('data-anahtar') }
        : { tur: 'baslik' };
    };

    var bekleyenVar = function () { return sepetUcusta > 0 || sepetZaman.size > 0; };

    var yenile = function () {
      try {
        sessionStorage.setItem(SEPET_ODAK_ANAHTARI, JSON.stringify({
          odak: sepetSonOdak, hatalar: sepetHatalar }));
      } catch (e) { /* gizli sekme vb. — odak geri yüklenmez, sepet çalışır */ }
      window.location.reload();
    };

    // Kuyruk tamamen boşaldığında TEK karar noktası.
    var kuyrukBitti = function () {
      if (sepetAyriliyor || bekleyenVar()) return;
      if (sepetSonYanit) sepetSayaciniGuncelle(sepetSonYanit.item_count);
      if (sepetOdemeBekliyor) {
        sepetOdemeBekliyor = false;
        if (!sepetHatalar.length && odemeForm) {
          // Gönderen düğmenin name="checkout" alanı programatik submit'te
          // gitmez; Shopify'ın checkout'a yönlendirmesi için elle eklenir.
          var c = document.createElement('input');
          c.type = 'hidden'; c.name = 'checkout'; c.value = '';
          odemeForm.appendChild(c);
          sepetAyriliyor = true;
          HTMLFormElement.prototype.submit.call(odemeForm);
          return;
        }
        odemeForm && odemeForm.removeAttribute('aria-busy');
      }
      // Yalnız hata olduysa ve hiçbir şey değişmediyse sayfa yenilenmez:
      // hata metni ekranda kalır. Bir şey değiştiyse yenilenir, hatalar
      // sessionStorage üzerinden yeni sayfadaki satıra geri yazılır.
      if (sepetDegisti) yenile();
    };

    var kuyrugaKoy = function (form, odak) {
      var eylem = form.getAttribute('action');
      if (!eylem) return;
      var govde = new URLSearchParams(new FormData(form)).toString();
      var li = form.closest('[data-anahtar]');
      var giris = form.querySelector('[data-sim-adet-deger]') ||
        (li && li.querySelector('[data-sim-adet-deger]'));
      var gonderilen = new URLSearchParams(govde).get('quantity');
      sepetUcusta++;
      if (li) li.setAttribute('aria-busy', 'true');
      satirHataYaz(form, '');
      sepetKuyruk = sepetKuyruk.then(function () {
        if (sepetAyriliyor) { sepetUcusta--; return; }
        return fetch(eylem + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded',
                     'Accept': 'application/json' },
          body: govde
        }).then(function (r) {
          return r.json().catch(function () { return null; }).then(function (j) {
            if (!r.ok) {
              var red = new Error('sepet reddedildi');
              red.yanit = j || {};
              throw red;
            }
            return j || {};
          });
        }).then(function (s) {
          sepetUcusta--;
          if (li) li.removeAttribute('aria-busy');
          sepetDegisti = true;
          sepetSonYanit = s;
          if (odak) sepetSonOdak = odak;
          if (giris) giris.dataset.onay = gonderilen;
          kuyrukBitti();
        }, function (hata) {
          sepetUcusta--;
          if (li) li.removeAttribute('aria-busy');
          if (hata && hata.yanit) {
            var metin = hata.yanit.description || hata.yanit.message ||
              'Sepet güncellenemedi, lütfen tekrar deneyin.';
            if (giris && giris.dataset.onay != null) {
              giris.value = giris.dataset.onay;
              giris.dataset.son = giris.dataset.onay;
            }
            satirHataYaz(form, metin);
            sepetHatalar.push({ anahtar: li ? li.getAttribute('data-anahtar') : null, metin: metin });
            kuyrukBitti();
            return;
          }
          // Ağ hatası: JS'siz yedeğe düş — formu tarayıcı gönderir.
          sepetAyriliyor = true;
          HTMLFormElement.prototype.submit.call(form);
        });
      });
    };

    // Bir adet formunun kutudaki değerini (değiştiyse) kuyruğa koyar.
    var adetGonder = function (form, odak) {
      var giris = form.querySelector('[data-sim-adet-deger]');
      if (!giris) return;
      var v = girisDegeri(giris);
      if (v === null) {
        giris.value = giris.dataset.son;
        kuyrukBitti();
        return;
      }
      giris.value = v;
      if (String(v) === giris.dataset.son) { kuyrukBitti(); return; }
      giris.dataset.son = String(v);
      // 0 = satır silinir; odak o satıra dönemez.
      if (v === 0 && odak) odak = silOdagi(form.closest('[data-anahtar]'));
      kuyrugaKoy(form, odak);
    };

    var zamanla = function (form, ms, odak) {
      clearTimeout(sepetZaman.get(form));
      sepetZaman.set(form, setTimeout(function () {
        sepetZaman.delete(form);
        adetGonder(form, odak);
      }, ms));
    };

    var bekleyeniIptal = function (form) {
      if (sepetZaman.has(form)) {
        clearTimeout(sepetZaman.get(form));
        sepetZaman.delete(form);
      }
    };

    // Her kutunun "son gönderilen" (son) ve "sunucunun onayladığı" (onay)
    // değeri — ikisi de sayfanın bastığı miktardan başlar.
    sepetKok.querySelectorAll('[data-sim-adet-deger]').forEach(function (g) {
      g.dataset.son = g.value;
      g.dataset.onay = g.value;
    });

    sepetKok.addEventListener('click', function (e) {
      var d = e.target.closest('[data-sim-adet]');
      if (!d || !sepetKok.contains(d)) return;
      var form = d.closest('[data-sim-adet-form]');
      var giris = form && form.querySelector('[data-sim-adet-deger]');
      if (!giris) return;
      var simdiki = girisDegeri(giris);
      if (simdiki === null) {
        // Geçersiz yazım (boş/negatif/harf): +/− onu "düzeltmeye" çalışıp
        // beklenmedik bir değer (ör. 0 → satır silinir) göndermez; kutu
        // son gönderilen değere döner, müşteri tekrar basar.
        giris.value = giris.dataset.son;
        return;
      }
      giris.value = d.dataset.simAdet === '+' ? simdiki + 1 : simdiki - 1;
      giris.value = girisDegeri(giris);               // 0..max'a kırp
      zamanla(form, 350, { tur: 'adet', anahtar: satirAnahtari(form), hedef: d.dataset.simAdet });
    });

    // K3: elle yazılan değer — iOS sayı klavyesinde Enter yok; "Bitti" ya
    // da başka bir yere dokunmak `change` üretir.
    sepetKok.addEventListener('change', function (e) {
      var giris = e.target.closest('[data-sim-adet-deger]');
      if (!giris) return;
      var form = giris.closest('[data-sim-adet-form]');
      if (form) zamanla(form, 300, { tur: 'adet', anahtar: satirAnahtari(form), hedef: 'giris' });
    });

    // Enter / "Güncelle" (JS'siz yedek) ve "Kaldır" — gerçek submit'ler,
    // JS varken kuyruğa çevrilir. "Siparişi Tamamla" da burada yakalanır.
    sepetKok.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('[data-sim-adet-form]')) {
        e.preventDefault();
        bekleyeniIptal(form);
        adetGonder(form, { tur: 'adet', anahtar: satirAnahtari(form), hedef: 'giris' });
        return;
      }
      if (form.matches('[data-sim-sil-form]')) {
        e.preventDefault();
        var li = form.closest('[data-anahtar]');
        var adetForm = li && li.querySelector('[data-sim-adet-form]');
        if (adetForm) {
          bekleyeniIptal(adetForm);
          var g = adetForm.querySelector('[data-sim-adet-deger]');
          if (g) g.dataset.son = '0';
        }
        kuyrugaKoy(form, silOdagi(li));
        return;
      }
      if (form === odemeForm) {
        // Gönderilmemiş (zamanlayıcıda bekleyen ya da hiç `change`
        // üretmemiş) her miktarı ŞİMDİ kuyruğa koy.
        sepetZaman.forEach(function (t) { clearTimeout(t); });
        sepetZaman.clear();
        sepetKok.querySelectorAll('[data-sim-adet-form]').forEach(function (f) {
          var g = f.querySelector('[data-sim-adet-deger]');
          if (g && String(girisDegeri(g)) !== g.dataset.son) adetGonder(f, null);
        });
        if (!bekleyenVar()) return;                    // her şey güncel → normal checkout
        e.preventDefault();
        sepetOdemeBekliyor = true;
        sepetHatalar = [];
        odemeForm.setAttribute('aria-busy', 'true');
      }
    });

    // Yenilemeden sonra: odağı geri koy, hataları satırlarına yaz, yeni
    // ara toplamı bir kez duyur.
    var kayit = null;
    try {
      kayit = JSON.parse(sessionStorage.getItem(SEPET_ODAK_ANAHTARI) || 'null');
      sessionStorage.removeItem(SEPET_ODAK_ANAHTARI);
    } catch (e) { kayit = null; }
    if (kayit) {
      var baslik = sepetKok.querySelector('[data-sim-sepet-baslik]');
      var satirBul = function (anahtar) {
        var bulunan = null;
        sepetKok.querySelectorAll('[data-anahtar]').forEach(function (li) {
          if (li.getAttribute('data-anahtar') === anahtar) bulunan = li;
        });
        return bulunan;
      };
      var hedef = null, o = kayit.odak;
      if (o && o.anahtar) {
        var satir = satirBul(o.anahtar);
        if (satir) {
          hedef = o.tur === 'satir' ? satir.querySelector('.sim-sepet-sayfa__ad')
            : o.hedef === 'giris' ? satir.querySelector('[data-sim-adet-deger]')
            : satir.querySelector('[data-sim-adet="' + o.hedef + '"]');
        }
      }
      if (!hedef) hedef = baslik;
      if (hedef) hedef.focus({ preventScroll: false });
      var durum = sepetKok.querySelector('[data-sim-sepet-durum]');
      var toplam = sepetKok.querySelector('[data-sim-ara-toplam] .sim-fiyat');
      setTimeout(function () {
        (kayit.hatalar || []).forEach(function (h) {
          var s = h.anahtar && satirBul(h.anahtar);
          var el = s && s.querySelector('[data-sim-satir-hata]');
          if (el) el.textContent = h.metin;
        });
        if (durum) {
          var metin = 'Sepet güncellendi.';
          if (toplam) {
            var kopya = toplam.cloneNode(true);
            kopya.querySelectorAll('.sim-gorsel-gizli').forEach(function (x) { x.remove(); });
            metin += ' Ara toplam: ' + kopya.textContent.trim();
          } else {
            metin += ' Sepetiniz boş.';
          }
          durum.textContent = metin;
        }
      }, 150);
    }

    // Dinleyiciler bağlandı — bölümün satır içi script'i `load`'da bunu
    // arar; yoksa JS'siz "Güncelle" düğmesini geri açar (section yorumu).
    sepetKok.setAttribute('data-sim-hazir', '');
  }
  } catch (e) {
    if (window.console && console.error) console.error('SİM sepet hatası:', e);
  }

  // ── ürün sayfası: varyant seçimi + sepete ekle ──
  // (Görev 7, Görev 7 düzeltmesi). Fiyat her güncellendiğinde
  // window.SIM.paraHtml çağrılır — burada yerel bir kuruş→TL biçimlendirme
  // KOPYASI YAZILMAZ; tek doğru kaynak dosyanın başındaki para()/paraHtml(),
  // window.SIM ile dışa açılıyor (bkz. bu IIFE'nin en altındaki atama).
  function urunKur(kok) {
    var veri = window.SIM_VARYANTLAR || [];
    var secili = [];
    // Buton yazısının ORİJİNAL (mağaza sahibinin ayarladığı) hâli —
    // "Tükendi" yazıp sonra stoklu bir varyanta dönüldüğünde geri
    // BURAYA dönülür. Önceden `else` dalı yoktu, yazı "Tükendi"de takılı
    // kalıyordu (Görev 7 inceleme B3). Sabit "Sepete Ekle" YAZILMAZ —
    // section ayarını data-atc-yazi ile taşıyoruz ki mağaza sahibinin
    // yazdığı metin JS'te tekrar edilmesin.
    var varsayilanYazi = kok.dataset.atcYazi || 'Sepete Ekle';
    var pulKaplar = kok.querySelectorAll('[data-sim-secenek]');
    pulKaplar.forEach(function (kap, i) {
      var basili = kap.querySelector('.sim-pul[aria-pressed="true"]');
      secili[i] = basili ? basili.dataset.deger : null;
      kap.addEventListener('click', function (e) {
        var p = e.target.closest('.sim-pul');
        if (!p || p.disabled) return;
        secili[i] = p.dataset.deger;
        kaydir(i);
        esitle();
      });
    });

    function eslesir(v, secim) {
      return secim.every(function (d, j) { return d === null || v.options[j] === d; });
    }

    function bul() {
      return veri.find(function (v) { return eslesir(v, secili); });
    }

    // Dal incelemesi madde 1 (KRİTİK): kullanıcı `i` eksenindeki bir değere
    // bastığında seçimin geri kalanıyla oluşan kombinasyon TÜKENMİŞSE,
    // o değeri taşıyan stoklu varyantlardan mevcut seçime EN YAKIN olana
    // kaydırılır (kullanıcının az önce seçtiği `i` ekseni korunur).
    // "En yakın" = diğer eksenlerde mevcut seçimle en çok örtüşen; eşitlikte
    // varyant listesindeki ilk sıra (Shopify'ın varyant sırası — mağaza
    // sahibinin belirlediği öncelik). Stoklu eşleşme yoksa seçim olduğu gibi
    // kalır, esitle() "Tükendi" gösterir.
    function kaydir(i) {
      var simdiki = bul();
      if (simdiki && simdiki.available) return;
      var enIyi = null, enIyiPuan = -1;
      veri.forEach(function (v) {
        if (!v.available || v.options[i] !== secili[i]) return;
        var puan = 0;
        secili.forEach(function (d, j) {
          if (j !== i && d !== null && v.options[j] === d) puan++;
        });
        if (puan > enIyiPuan) { enIyi = v; enIyiPuan = puan; }
      });
      if (enIyi) secili = enIyi.options.slice(0, secili.length);
    }

    // Pul durumu — İKİ AYRI kavram (dal incelemesi madde 1):
    //  · `disabled`: değeri taşıyan HİÇBİR stoklu varyant yok (diğer
    //    eksenlerden bağımsız). Yalnız bu durumda pul tıklanamaz.
    //    Önceki mantık pulu "mevcut seçimle birlikte" stok yoksa
    //    kilitliyordu: Renk×Boy'da yalnız Altın/32 + Gümüş/45 stoklu ve
    //    Altın/32 seçiliyken Gümüş de 45 de kilitleniyordu → stokta olan
    //    Gümüş/45 ULAŞILAMAZ oluyordu; `?variant=` ile tükenmiş bir
    //    kombinasyona gelinince bütün düğmeler kilitlenebiliyordu.
    //  · `.sim-pul--tukendi`: değer başka kombinasyonlarda stoklu ama
    //    MEVCUT seçimle birleşince tükenik. Görsel olarak soluk/çizili,
    //    TIKLANABİLİR — basılınca kaydir() stoklu kombinasyona taşır.
    // Durum yalnız renkle/çizgiyle anlatılmaz: pulun içindeki görsel-gizli
    // [data-sim-pul-durum] metni ekran okuyucuya "tükendi" der.
    function pulleriGuncelle() {
      pulKaplar.forEach(function (kap, i) {
        kap.querySelectorAll('.sim-pul').forEach(function (p) {
          var deger = p.dataset.deger;
          var herhangiStok = veri.some(function (v) {
            return v.available && v.options[i] === deger;
          });
          var deneme = secili.slice();
          deneme[i] = deger;
          var bununlaStok = veri.some(function (v) {
            return v.available && eslesir(v, deneme);
          });
          p.disabled = !herhangiStok;
          p.classList.toggle('sim-pul--tukendi', herhangiStok && !bununlaStok);
          p.setAttribute('aria-pressed', String(secili[i] === deger));
          var durum = p.querySelector('[data-sim-pul-durum]');
          if (durum) {
            durum.textContent = !herhangiStok ? ' (tükendi)'
              : (!bununlaStok ? ' (bu seçimle tükendi)' : '');
          }
        });
      });
    }

    function esitle() {
      var v = bul();
      kok.querySelectorAll('[data-sim-atc]').forEach(function (b) {
        b.disabled = !v || !v.available;
        b.dataset.varyant = v ? v.id : '';
        var y = b.querySelector('[data-sim-atc-yazi]');
        // B3: `else` dalı eklendi — tükenmiş bir kombinasyondan stoklu
        // bir kombinasyona dönüldüğünde yazı varsayılana GERİ DÖNER.
        if (y) y.textContent = (!v || !v.available) ? 'Tükendi' : varsayilanYazi;
      });
      // no-JS yedeği olan formun gizli `id` alanı da seçimi izler.
      var gizliId = kok.querySelector('[data-sim-atc-id]');
      if (gizliId && v) gizliId.value = v.id;
      // Vitrin: sabit çubuktaki varyant seçici seçimi izler.
      var cubukSecim = kok.querySelector('[data-sim-sticky-varyant]');
      if (cubukSecim && v) cubukSecim.value = String(v.id);
      pulleriGuncelle();
      if (!v) return;
      // Fiyat kutusu TAMAMEN yeniden kurulur (fiyatHtml): ana fiyat,
      // görsel-gizli "Fiyat:" etiketi ve — yalnız compare_at_price > price
      // ise — çizili eski fiyat. Önceki yorum "uydurma indirim göstermemek
      // için çizili fiyata bilerek dokunulmuyor" diyordu; mantık tersti:
      // dokunulmadığı için ilk varyantın çizili fiyatı indirimsiz varyanta
      // geçince ekranda KALIYORDU (dal incelemesi madde 2).
      var kutuHtml = window.SIM.fiyatHtml(v.price, v.compare_at_price);
      kok.querySelectorAll('[data-sim-fiyat],[data-sim-sticky-fiyat]')
        .forEach(function (el) { el.innerHTML = kutuHtml; });
      // Vitrin: "İndirim" rozeti yalnız GERÇEK indirimde (sim-fiyat ile aynı kural).
      kok.querySelectorAll('[data-sim-indirim]').forEach(function (el) {
        el.hidden = !(v.compare_at_price !== null && v.compare_at_price !== undefined &&
                      Number(v.compare_at_price) > Number(v.price));
      });
      // B12: seçilen varyant URL'e yazılır — sayfa yenilenince ya da link
      // paylaşılınca Shopify `?variant=` olmadan İLK varyanta döner,
      // ziyaretçi seçtiği kombinasyonu kaybederdi. Piksel/katalog
      // eşleşmesi de varyant kırılımını bu sayede korur.
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) { /* eski tarayıcı/URL desteği yoksa sessizce atla */ }
      }
      // 2026-09-30: küçük resim şeridi varsa galeri bu varyantın görseline
      // gider (galeriKur dinler). Şerit yoksa dinleyici yok, olay etkisiz.
      try { kok.dispatchEvent(new CustomEvent('sim:varyant', { detail: v })); } catch (e) { /* yok say */ }
      paketGuncelle(v);
    }

    // ── paket seçici (1 adet / 2'li set) — 2026-10-07 ─────────────
    // Radyo düğmeleri formun içinde, adı `quantity`: JS yoksa tarayıcının
    // POST'u seçilen adedi gönderir. Seçili paketin toplamı fiyat kutusuna
    // ve sticky çubuğa yazılır. İndirimi TEMA HESAPLAMAZ (Shopify otomatik
    // indirimi uygular); bu yalnız aynı yüzdeyle ön gösterimdir — Liquid'deki
    // hesapla birebir (tam sayı kuruş, aşağı yuvarlama).
    var paketKap = kok.querySelector('[data-sim-paket]');
    // ikili: seçili varyantın kendi ikili set indirimi (kuruş, sim.ikili_indirim);
    // doluysa blok tutarının ve yüzdenin önüne geçer (baykuş, 2026-10-18).
    // eski: varyantın compare_at_price'ı (kuruş). Fiyattan büyükse çizili rakam
    // adet × eski olur (2026-10-24, kertenkele); yoksa adet × fiyat — Liquid'le aynı.
    function paketToplam(fiyat, r, ikili, eski) {
      var adet = parseInt(r.dataset.adet, 10) || 1;
      var yuzde = parseInt(r.dataset.yuzde, 10) || 0;
      var tutar = parseInt(r.dataset.tutar, 10) || 0;   // kuruş; doluysa yüzdenin yerine geçer
      if (ikili > 0) tutar = ikili;
      var tam = fiyat * adet;
      var referans = (eski !== null && eski !== undefined && Number(eski) > fiyat) ? Number(eski) : fiyat;
      var indirim = adet > 1 ? (tutar > 0 ? tutar : Math.floor(fiyat * yuzde / 100)) : 0;
      return { tam: tam, toplam: tam - indirim, cizili: referans * adet };
    }
    function paketGuncelle(v) {
      if (!paketKap || !v) return;
      var secilen = null;
      paketKap.querySelectorAll('input[type="radio"]').forEach(function (r) {
        var t = paketToplam(v.price, r, v.ikili, v.compare_at_price);
        var kutu = r.closest('.sim-paket__k').querySelector('[data-sim-paket-fiyat]');
        if (kutu) kutu.innerHTML = window.SIM.fiyatHtml(t.toplam, t.cizili);
        // Eşik üstü ek ("kargo bedava"): yalnız toplam kargo eşiğini geçince.
        var ek = r.closest('.sim-paket__k').querySelector('[data-sim-paket-esik]');
        if (ek) {
          var es = (parseInt(kok.dataset.kapidaEsik, 10) || 0) * 100;
          ek.hidden = es > 0 && t.toplam < es;
        }
        if (r.checked) secilen = t;
      });
      if (!secilen) return;
      var html = window.SIM.fiyatHtml(secilen.toplam, secilen.cizili);
      kok.querySelectorAll('[data-sim-fiyat],[data-sim-sticky-fiyat]')
        .forEach(function (el) { el.innerHTML = html; });
    }
    if (paketKap) {
      paketKap.addEventListener('change', function () { paketGuncelle(bul()); });
    }

    // ── kapıda ödeme kargo notu — 2026-10-13 ────────────────────
    // Kullanıcı kararı (bütün site): kartla ödemede kargo bedava,
    // kapıda ödemede eşik altı +149 ₺. Not EasySell'in kapıda ödeme
    // düğmesinin hemen ÜSTÜNE yazılır ve yalnız seçili sepet eşiğin
    // altındaysa görünür — 2'li sette (kargo bedava) gizlenir, yazı
    // formdaki toplamla hep aynı kalır. EasySell düğmeyi sayfa
    // yüklendikten sonra eklediği için MutationObserver onu bekler.
    var kapidaNot = kok.dataset.kapidaNot || '';
    var kapidaEsik = (parseInt(kok.dataset.kapidaEsik, 10) || 0) * 100;
    function kapidaToplam() {
      var v = bul();
      if (!v) return null;
      var r = kok.querySelector('[data-sim-paket] input[type="radio"]:checked');
      if (r) return paketToplam(v.price, r, v.ikili).toplam;
      var g = kok.querySelector('[data-sim-sa-adet-giris]');
      return v.price * (g ? Math.max(1, parseInt(g.value, 10) || 1) : 1);
    }
    function kapidaNotGuncelle() {
      var es = kok.querySelector('.es-popup-button-product');
      if (!kapidaNot || !es || !es.parentNode) return;
      var p = kok.querySelector('[data-sim-kapida-not]');
      if (!p) {
        p = document.createElement('p');
        p.className = 'sim-kapida-not';
        p.setAttribute('data-sim-kapida-not', '');
        p.textContent = kapidaNot;
      }
      if (p.nextElementSibling !== es) es.parentNode.insertBefore(p, es);
      var t = kapidaToplam();
      var gizle = t === null || (kapidaEsik > 0 && t >= kapidaEsik);
      if (p.hidden !== gizle) p.hidden = gizle;
    }
    if (kapidaNot) {
      kok.addEventListener('change', kapidaNotGuncelle);
      kok.addEventListener('input', kapidaNotGuncelle);
      kok.addEventListener('click', function (e) {
        if (e.target.closest('[data-sim-sa-adet-dugme]')) setTimeout(kapidaNotGuncelle, 0);
      });
      kok.addEventListener('sim:varyant', kapidaNotGuncelle);
      if (window.MutationObserver) {
        new MutationObserver(kapidaNotGuncelle).observe(kok, { childList: true, subtree: true });
      }
      kapidaNotGuncelle();
    }

    var form = kok.querySelector('[data-sim-atc-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        // Normal çalışmada HER ZAMAN preventDefault: sepete fetch ile
        // eklenir, sayfa yenilenmez (spec — form submit ziyaretçiyi
        // /cart'a atlatırdı). JS hiç çalışmazsa bu dinleyici hiç
        // bağlanmaz ve tarayıcı GERÇEK bir POST yapar — B7'nin no-JS
        // yedeği budur.
        e.preventDefault();
        var v = bul();
        if (!v || !v.available) return;
        var not = kok.querySelector('[data-sim-atc-not]');
        var atcButonlari = kok.querySelectorAll('[data-sim-atc]');

        var seciliPaket = kok.querySelector('[data-sim-paket] input[type="radio"]:checked');
        // Paket yoksa adet kutusunun değeri (vitrin, adetKur); ikisi de yoksa 1.
        var adetGiris = kok.querySelector('[data-sim-sa-adet-giris]');
        var adet = seciliPaket ? (parseInt(seciliPaket.value, 10) || 1)
          : (adetGiris ? Math.max(1, parseInt(adetGiris.value, 10) || 1) : 1);
        var items = [{ id: v.id, quantity: adet }];

        // Dal incelemesi madde 6: sepet uç noktaları SABİT YAZILMAZ.
        // Dil/pazar öneki olan mağazada (/en/cart/add) sabit '/cart/add.js'
        // yönlendirmeye düşer, POST gövdesi kaybolur ve arayüz yine
        // "Sepete eklendi." derdi. Ekleme adresi formun Liquid'in bastığı
        // `action`'ından (routes.cart_add_url), sepet adresi bölüm kökündeki
        // data-sepet-url'den (routes.cart_url) türetilir; `.js` son eki
        // Shopify'ın AJAX API sözleşmesidir.
        var ekleUrl = form.getAttribute('action');
        var sepetUrl = kok.dataset.sepetUrl;
        if (!ekleUrl || !sepetUrl) {
          if (not) { not.hidden = false; not.textContent = 'Eklenemedi, tekrar deneyin.'; }
          return;
        }
        atcButonlari.forEach(function (b) { b.disabled = true; });
        fetch(ekleUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('sepet');
          return r.json();
        }).then(function () {
          return fetch(sepetUrl + '.js').then(function (r) {
            if (!r.ok) throw new Error('sepet');
            return r.json();
          });
        }).then(function (s) {
          window.SIM.sepetSayaciniGuncelle(s.item_count);
          if (not) { not.hidden = false; not.textContent = 'Sepete eklendi.'; }
          // Reklam landing'i: bölüm ayarı açıksa doğrudan sepete gidilir.
          // 2026-10-17 (kullanıcı): kamera ve yüzük şimdilik böyle kalıyor —
          // bu ayar çekmeceden ÖNCE gelir.
          if (kok.dataset.sepeteGit === 'true') { window.location.href = sepetUrl; return; }
          // Sepet çekmecesi (2026-10-16) varsa ve ayarı açıksa sayfadan
          // ayrılmadan o açılır. Çizim gelmezse sepet sayfasına düşülür
          // (ürün zaten sepette).
          if (sepetCekmecesi && sepetCekmecesi.atcAc) {
            sepetCekmecesi.yenileVeAc().catch(function () { window.location.href = sepetUrl; });
            return;
          }
        }).catch(function () {
          if (not) {
            not.hidden = false;
            not.textContent = 'Eklenemedi, tekrar deneyin.';
          }
        }).finally(function () {
          // Butonları tek tek `false` yapmak yerine esitle() çağrılır:
          // istek sürerken varyant DEĞİŞMEDİ (form doldururken pul
          // tıklanamaz değil ama olası bir yarış durumunda da doğru
          // disabled/yazı durumuna döner — tek doğru kaynak esitle()).
          esitle();
        });
      });
    }

    // Sticky çubuk ana butonun görünürlüğüne bağlı: buton ekrandayken
    // çubuk gizli, kaydırıp geçince beliriyor. Sabit bir kaydırma eşiğine
    // bağlamak farklı ekran boylarında ya erken ya geç tetikliyordu.
    // Vitrin (spec D): çubuk yalnız sayfadaki düğme ekranın ÜSTÜNDEN çıkınca
    // görünür; düğme henüz aşağıdaysa (sayfa açılışı) görünmez.
    // IntersectionObserver YERİNE kaydırma dinleyicisi: düğme "aşağıda görünmez"
    // hâlinden "yukarıda görünmez" hâline tek sıçramada geçerse (çapa linki,
    // hızlı kaydırma) kesişim hiç değişmez, gözlemci hiç tetiklenmezdi.
    // capture: ≥990'da Horizon .page-wrapper'ı kaydırır, onun scroll olayı
    // kabarcıklanmaz ama yakalama evresinde document'a ulaşır.
    var cubuk = kok.querySelector('[data-sim-sticky]');
    var atc = kok.querySelector('.sim-sa-sag [data-sim-atc]');
    if (cubuk && atc) {
      var cubukBekliyor = false;
      var cubukDurum = function () {
        cubukBekliyor = false;
        cubuk.hidden = atc.getBoundingClientRect().bottom > 0;
      };
      var cubukIste = function () {
        if (cubukBekliyor) return;
        cubukBekliyor = true;
        requestAnimationFrame(cubukDurum);
      };
      document.addEventListener('scroll', cubukIste, { capture: true, passive: true });
      window.addEventListener('resize', cubukIste);
      cubukDurum();
    }
    // Vitrin: çubuktaki varyant seçici sayfadaki pulları sürer.
    var cubukSecim = kok.querySelector('[data-sim-sticky-varyant]');
    if (cubukSecim) {
      cubukSecim.addEventListener('change', function () {
        var v = veri.find(function (x) { return String(x.id) === cubukSecim.value; });
        if (!v) return;
        secili = v.options.slice(0, pulKaplar.length);
        esitle();
      });
    }

    // Sticky çubuğun GERÇEK yüksekliği --sim-sticky-h CSS değişkenine
    // yazılır; CSS bu değeri body'nin alt dolgusunda kullanır (bkz.
    // sim-simyahane.css). `resize`/`load` YETERSİZDİ: mağaza sahibinin
    // uzun buton metni (satır sarması) ya da Inter'in display:swap ile
    // sonradan yüklenip satır yüksekliğini değiştirmesi `resize`
    // üretmez ama çubuğun border-box yüksekliğini DEĞİŞTİRİR —
    // ResizeObserver ikisini de yakalar (Görev 7 inceleme sticky-bar
    // hükmü). `body.style.paddingBottom` YAZILMIYOR: <body> taban temanın
    // (Horizon) layout/theme.liquid'inde, yani bu bölümün sahip olmadığı bir
    // düğüm — satır içi stilini ele geçirmek yerine bildirimsel bir CSS
    // özel özelliği + `:has()` kuralı kullanılıyor (kaynak: CSS dosyası).
    if (cubuk && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        document.documentElement.style.setProperty('--sim-sticky-h', cubuk.offsetHeight + 'px');
      }).observe(cubuk);
    }

    esitle();
  }

  // ── ürün galerisi: küçük resim şeridi (2026-09-30) ──────────────
  // YALNIZ [data-sim-galeri] varsa çalışır (ayar: kucuk_resim). Diğer
  // sayfalarda bu öğe basılmaz, fonksiyon hiç çağrılmaz. Küçük resme
  // dokununca o kareye kayar; kaydırınca seçili küçük resim güncellenir;
  // yalnız ekrandaki video oynar; varyant seçilince o varyantın görseline gider.
  function galeriKur(g) {
    var kok = g.closest('[data-sim-urun]');
    var serit = kok && kok.querySelector('[data-sim-galeri-serit]');
    var kareler = g.querySelectorAll('[data-sim-galeri-k]');
    if (!serit || !kareler.length) return;
    var dugmeler = serit.querySelectorAll('[data-sim-galeri-git]');
    var aktif = -1;
    function konum(el, kap) {
      return kap.scrollLeft + (el.getBoundingClientRect().left - kap.getBoundingClientRect().left);
    }
    function isaretle(i) {
      if (i === aktif) return;
      aktif = i;
      dugmeler.forEach(function (d, n) {
        var on = n === i;
        d.classList.toggle('is-on', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      var d = dugmeler[i];
      if (d) serit.scrollTo({ left: Math.max(0, konum(d, serit) - (serit.clientWidth - d.clientWidth) / 2), behavior: 'smooth' });
      kareler.forEach(function (k, n) {
        var v = k.querySelector('video');
        if (!v) return;
        if (n === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }
    function git(i) {
      var k = kareler[i];
      if (!k) return;
      g.scrollTo({ left: konum(k, g), behavior: 'smooth' });
      isaretle(i);
    }
    dugmeler.forEach(function (d) {
      d.addEventListener('click', function () { git(parseInt(d.getAttribute('data-sim-galeri-git'), 10)); });
    });
    var bekle;
    g.addEventListener('scroll', function () {
      clearTimeout(bekle);
      bekle = setTimeout(function () {
        var orta = g.scrollLeft + g.clientWidth / 2, en = 0, fark = Infinity;
        kareler.forEach(function (k, n) {
          var m = konum(k, g) + k.clientWidth / 2;
          if (Math.abs(m - orta) < fark) { fark = Math.abs(m - orta); en = n; }
        });
        isaretle(en);
      }, 90);
    }, { passive: true });
    kok.addEventListener('sim:varyant', function (e) {
      var id = e.detail && e.detail.media;
      if (!id) return;
      for (var n = 0; n < kareler.length; n++) {
        if (kareler[n].getAttribute('data-medya-id') === String(id)) { if (n !== aktif) git(n); break; }
      }
    });
    isaretle(0);
  }

  // ── reels şeridi (2026-09-30) ─────────────────────────────────
  // YALNIZ [data-sim-reels] varsa çalışır (şablonda `reel` bloğu). Ekranda
  // en az %60 görünen kart oynar, diğerleri durur; dokununca durur/oynar.
  // Hareket azaltma tercihinde hiçbiri kendiliğinden oynamaz.
  function reelsKur(kap) {
    var videolar = kap.querySelectorAll('video');
    if (!videolar.length) return;
    var azalt = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function oynat(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!azalt && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (kayitlar) {
        kayitlar.forEach(function (k) {
          var v = k.target;
          if (k.isIntersecting && k.intersectionRatio >= 0.6 && !v.dataset.simDurdu) oynat(v);
          else v.pause();
        });
      }, { threshold: [0, 0.6, 1] });
      videolar.forEach(function (v) { io.observe(v); });
    }
    videolar.forEach(function (v) {
      v.addEventListener('click', function () {
        if (v.paused) { delete v.dataset.simDurdu; oynat(v); }
        else { v.dataset.simDurdu = '1'; v.pause(); }
      });
    });
  }

  // ── ürün sayfası: adet kutusu (paket yoksa) — vitrin 2026-10-08 ──
  // − / + kökteki BÜTÜN adet girişlerini (sayfadaki kutu ve sabit çubuktaki
  // kopyası) aynı değere getirir; birine yazılan değer ötekine yansır. Sepete
  // eklerken urunKur bu değeri okur. 1–99 arası; boş/geçersiz → 1.
  function adetKur(kok) {
    var girisler = function () { return kok.querySelectorAll('[data-sim-sa-adet-giris]'); };
    if (!girisler().length) return;
    var yaz = function (n, haric) {
      n = Math.max(1, Math.min(99, n || 1));
      girisler().forEach(function (g) { if (g !== haric) g.value = n; });
    };
    kok.addEventListener('click', function (e) {
      var d = e.target.closest('[data-sim-sa-adet-dugme]');
      if (!d) return;
      var ilk = girisler()[0];
      yaz((parseInt(ilk.value, 10) || 1) + parseInt(d.getAttribute('data-sim-sa-adet-dugme'), 10));
    });
    kok.addEventListener('input', function (e) {
      var g = e.target.closest('[data-sim-sa-adet-giris]');
      var n = g ? parseInt(g.value, 10) : NaN;
      if (n > 0) yaz(n, g);
    });
    kok.addEventListener('change', function (e) {
      var g = e.target.closest('[data-sim-sa-adet-giris]');
      if (g) yaz(parseInt(g.value, 10));
    });
  }

  // ── kargo saati — 2026-10-17 ──────────────────────────────────
  // snippets/sim-kargo-saati.liquid. Türkiye saati: UTC+3 (2016'dan beri yaz
  // saati yok) — Date.now()'a 3 saat eklenip UTC alanları okunur, böylece
  // ziyaretçinin cihazı hangi saat diliminde olursa olsun İstanbul duvar
  // saati çıkar. Bugün kesimden önceyse kalan süre, değilse kargo çıkan ilk
  // gün (yarın / gün adı / tarih) yazılır; 30 sn'de bir tazelenir.
  try {
    var ksSatirlar = document.querySelectorAll('[data-sim-kargo-saati]');
    if (ksSatirlar.length) {
      var KS_GUN = ['pazar', 'pazartesi', 'salı', 'çarşamba', 'perşembe', 'cuma', 'cumartesi'];
      var KS_AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos',
                   'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      var ksDakika = function (s) {
        var m = /^(\d{1,2})[:.](\d{2})$/.exec(String(s || '').trim());
        return m ? Number(m[1]) * 60 + Number(m[2]) : null;
      };
      var ksYaz = function (el) {
        var kesim = [ksDakika(el.getAttribute('data-pazar')), null, null, null, null, null,
                     ksDakika(el.getAttribute('data-cumartesi'))];
        var hi = ksDakika(el.getAttribute('data-hafta-ici'));
        for (var g = 1; g <= 5; g++) kesim[g] = hi;
        var kapali = (el.getAttribute('data-kapali') || '').split(',');
        var simdi = Date.now() + 3 * 3600000;               // İstanbul duvar saati (UTC alanlarında)
        var bugun = new Date(simdi);
        var gunBasi = Date.UTC(bugun.getUTCFullYear(), bugun.getUTCMonth(), bugun.getUTCDate());
        var acik = function (d) {
          return kesim[d.getUTCDay()] !== null && kapali.indexOf(d.toISOString().slice(0, 10)) < 0;
        };
        var metin = null;
        if (acik(bugun)) {
          var kalan = Math.ceil((gunBasi + kesim[bugun.getUTCDay()] * 60000 - simdi) / 60000);
          if (kalan > 0) {
            var sa = Math.floor(kalan / 60), dk = kalan % 60;
            var sure = (sa ? sa + ' saat' : '') + (sa && dk ? ' ' : '') + (dk || !sa ? dk + ' dakika' : '');
            metin = '<strong>' + sure + '</strong> içinde sipariş verirseniz bugün kargoda.';
          }
        }
        if (!metin) {
          for (var i = 1; i <= 14; i++) {
            var d = new Date(gunBasi + i * 86400000);
            if (!acik(d)) continue;
            var ad = i === 1 ? 'yarın' : (i < 7 ? KS_GUN[d.getUTCDay()]
              : d.getUTCDate() + ' ' + KS_AY[d.getUTCMonth()]);
            metin = 'Şimdi sipariş verirseniz <strong>' + ad + '</strong> kargoda.';
            break;
          }
        }
        var yer = el.querySelector('[data-sim-kargo-saati-metin]');
        if (metin && yer) { yer.innerHTML = metin; el.hidden = false; } else { el.hidden = true; }
      };
      var ksHepsi = function () { ksSatirlar.forEach(ksYaz); };
      ksHepsi();
      setInterval(ksHepsi, 30000);
    }
  } catch (e) {
    if (window.console && console.error) console.error('SİM kargo saati hatası:', e);
  }

  // ── sepet çekmecesi — 2026-10-16 ──────────────────────────────
  // sections/sim-sepet-cekmece.liquid. Açılır: header'daki sepet bağlantısı
  // (data-sim-sepet; JS yoksa /cart'a gider) ve ürün sayfasında başarılı
  // Sepete Ekle (bölüm ayarı atc_ac → sepetCekmecesi.atcAc). İçerik
  // Shopify'ın Section Rendering API'sinden gelir (?sections=<section.id>;
  // ekleme/değiştirmede aynı çizim `sections` parametresiyle yanıtta) —
  // tema fiyat, indirim, eşik HESAPLAMAZ, Liquid'in bastığını koyar.
  // Yalnız [data-sim-cekmece-govde] ve [data-sim-cekmece-ozet] değişir;
  // ödeme formu HİÇ yeniden çizilmez: EasySell kendi "Kapıda ödeme"
  // düğmesini oraya bir kez koyuyor, form değişirse düğme kaybolurdu.
  // Aynı anda tek istek (ckMesgul): hızlı ardışık tıklar bırakılır, gövde
  // aria-busy ile soluklaşır; hata Shopify'ın açıklamasıyla role=alert'e.
  var sepetCekmecesi = null;
  try {
    var ck = document.querySelector('[data-sim-cekmece]');
    if (ck) {
      var ckPanel = ck.querySelector('.sim-cekmece__panel');
      var ckBolum = ck.getAttribute('data-bolum');
      var ckKok = ck.getAttribute('data-kok') || '/';
      var ckKapatZ = null;
      var ckOncekiOdak = null;
      var ckMesgul = false;
      var ckAcik = function () { return ck.classList.contains('sim-cekmece--acik'); };

      var ckAc = function (ac, odakGeriVerme) {
        clearTimeout(ckKapatZ);
        if (ac) {
          if (!ckAcik()) ckOncekiOdak = document.activeElement;
          ck.hidden = false;
          // hidden kalktıktan SONRAKİ karede sınıf: geçiş ilk karede atlanmasın.
          requestAnimationFrame(function () {
            ck.classList.add('sim-cekmece--acik');
            var b = ck.querySelector('#SimCekmeceBaslik');
            if (b) b.focus();
          });
        } else {
          if (ck.hidden) return;
          ck.classList.remove('sim-cekmece--acik');
          ckKapatZ = setTimeout(function () { ck.hidden = true; }, 240);
          if (!odakGeriVerme && ckOncekiOdak && typeof ckOncekiOdak.focus === 'function' &&
              document.contains(ckOncekiOdak)) {
            ckOncekiOdak.focus();
          }
          ckOncekiOdak = null;
        }
        document.documentElement.classList.toggle('sim-kilit', ac);
        document.documentElement.classList.toggle('sim-cekmece-acik', ac);
      };

      var ckHata = function (metin) {
        var h = ck.querySelector('[data-sim-cekmece-hata]');
        if (h) h.textContent = metin || '';
      };

      // Yeni çizimi yerleştirir; odak, aynı data-odak'lı denetime (yoksa
      // başlığa) geri döner — silinen satırın düğmesi DOM'dan gidince odak
      // perdenin arkasına düşmesin.
      var ckYaz = function (html) {
        if (!html) return false;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var yeniGovde = d.querySelector('[data-sim-cekmece-govde]');
        if (!yeniGovde) return false;
        var aktif = document.activeElement;
        var odak = aktif && ck.contains(aktif) ? aktif.getAttribute('data-odak') : null;
        var govde = ck.querySelector('[data-sim-cekmece-govde]');
        govde.innerHTML = yeniGovde.innerHTML;
        var adet = parseInt(yeniGovde.getAttribute('data-adet'), 10) || 0;
        govde.setAttribute('data-adet', String(adet));
        var ozet = ck.querySelector('[data-sim-cekmece-ozet]');
        var yeniOzet = d.querySelector('[data-sim-cekmece-ozet]');
        if (ozet && yeniOzet) ozet.innerHTML = yeniOzet.innerHTML;
        var alt = ck.querySelector('[data-sim-cekmece-alt]');
        if (alt) alt.hidden = adet === 0;
        var sayi = ck.querySelector('[data-sim-cekmece-sayi]');
        if (sayi) sayi.textContent = '(' + adet + ')';
        sepetSayaciniGuncelle(adet);
        if (odak) {
          var hedef = ck.querySelector('[data-odak="' + odak + '"]') || ck.querySelector('#SimCekmeceBaslik');
          if (hedef) hedef.focus();
        }
        return true;
      };

      var ckYenile = function () {
        var url = ckKok + (ckKok.indexOf('?') < 0 ? '?' : '&') + 'sections=' + encodeURIComponent(ckBolum);
        return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('bolum');
            return r.json();
          })
          .then(function (j) {
            if (!ckYaz(j && j[ckBolum])) throw new Error('bolum');
          });
      };

      // basaKaydir: öneriden ekleyince liste başa kayar — "İndiriminiz
      // uygulandı" mesajı ve yeni satır görünür (Ekle düğmesi en alttaydı).
      var ckGonder = function (url, veri, basaKaydir) {
        if (ckMesgul || !url) return;
        ckMesgul = true;
        var g = ck.querySelector('[data-sim-cekmece-govde]');
        g.setAttribute('aria-busy', 'true');
        ckHata('');
        veri.sections = ckBolum;
        veri.sections_url = window.location.pathname;
        fetch(url + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(veri)
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) {
              var e = new Error('sepet');
              e.metin = j.description || j.message;
              throw e;
            }
            return j;
          });
        }).then(function (j) {
          // Yanıtta çizim yoksa (eski API / önbellek) ayrı istekle çekilir.
          return (ckYaz(j.sections && j.sections[ckBolum]) ? Promise.resolve() : ckYenile())
            .then(function () {
              var k = basaKaydir && ck.querySelector('.sim-cekmece__kaydir');
              if (k) k.scrollTop = 0;
            });
        }).catch(function (e) {
          ckHata((e && e.metin) || 'Sepet güncellenemedi, tekrar deneyin.');
          var b = ck.querySelector('[data-sim-cekmece-ekle][aria-disabled]');
          if (b) b.removeAttribute('aria-disabled');
        }).then(function () {
          ckMesgul = false;
          var g2 = ck.querySelector('[data-sim-cekmece-govde]');
          if (g2) g2.removeAttribute('aria-busy');
        });
      };

      document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (e.target.closest('[data-sim-sepet]')) {
          e.preventDefault();
          ckAc(true);
          ckYenile().catch(function () { /* sayfa yüklenirken basılan içerik kalır */ });
          return;
        }
        if (!ck.contains(e.target)) return;
        if (e.target.closest('[data-sim-cekmece-kapa]')) { ckAc(false); return; }
        // EasySell'in çekmece düğmesi formu açar; çekmece kapanır, odak
        // EasySell penceresinde kalsın diye geri VERİLMEZ.
        if (e.target.closest('.es-popup-button-drawer')) { ckAc(false, true); return; }
        var ekle = e.target.closest('[data-sim-cekmece-ekle]');
        if (ekle) {
          e.preventDefault();
          if (ckMesgul) return;
          ekle.setAttribute('aria-disabled', 'true');
          ckGonder(ck.getAttribute('data-ekle-url'),
            { items: [{ id: Number(ekle.getAttribute('data-sim-cekmece-ekle')), quantity: 1 }] }, true);
          return;
        }
        // −, +, Kaldır: formun gönderim düğmeleri; değer düğmenin kendisinde.
        var adetDugme = e.target.closest('[data-sim-cekmece-adet-form] button[name="quantity"]');
        if (adetDugme) {
          e.preventDefault();
          var f = adetDugme.form;
          ckGonder(f.getAttribute('action'), {
            id: f.querySelector('input[name="id"]').value,
            quantity: Math.max(0, parseInt(adetDugme.value, 10) || 0)
          });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!ckAcik()) return;
        if (e.key === 'Escape') { ckAc(false); return; }
        if (e.key !== 'Tab') return;
        var el = Array.prototype.filter.call(
          ckPanel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'),
          function (x) { return x.getAttribute('tabindex') !== '-1' && x.offsetParent !== null; });
        if (!el.length) return;
        var ilk = el[0], son = el[el.length - 1];
        if (e.shiftKey && (document.activeElement === ilk || !ckPanel.contains(document.activeElement))) {
          e.preventDefault(); son.focus();
        } else if (!e.shiftKey && (document.activeElement === son || !ckPanel.contains(document.activeElement))) {
          e.preventDefault(); ilk.focus();
        }
      });

      // Geri tuşuyla önbellekten dönülünce (bfcache) sepet başka sekmede
      // değişmiş olabilir: çekmece kapanır, içerik sessizce tazelenir.
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        ckAc(false, true);
        ckYenile().catch(function () {});
      });

      sepetCekmecesi = {
        atcAc: ck.getAttribute('data-atc-ac') === 'true',
        ac: function () { ckAc(true); },
        yenile: ckYenile,
        // Sepete Ekle sonrası: önce Shopify'dan taze çizim, sonra aç. Çizim
        // gelmezse reddedilir — çağıran sepet sayfasına düşer.
        yenileVeAc: function () { return ckYenile().then(function () { ckAc(true); }); }
      };
    }
  } catch (e) {
    if (window.console && console.error) console.error('SİM sepet çekmecesi hatası:', e);
  }

  window.SIM = { para: para, paraHtml: paraHtml, fiyatHtml: fiyatHtml,
                 sepetSayaciniGuncelle: sepetSayaciniGuncelle,
                 sepetCekmecesi: sepetCekmecesi };

  // urunKur() çağrısı window.SIM ATANDIKTAN SONRA yapılır: esitle() ilk
  // kez burada çalışır ve içeride window.SIM.paraHtml() çağrılır — sırası
  // ters olsaydı (atamadan önce çağrılsaydı) ilk eşitlemede window.SIM
  // henüz tanımsız olurdu.
  //
  // B7: her bölümün kurulumu KENDİ try/catch'i içinde. Önceden tüm bölüm
  // kurulumları (drawer, hero video, ürün sayfası) TEK bir üst kapsamda
  // sırayla çalışıyordu — herhangi biri (ör. drawer) istisna atarsa
  // ondan SONRA gelen hiçbir kod (urunKur dahil) hiç çalışmıyordu ve
  // "Sepete Ekle" görünür ama tıklanınca sessizce hiçbir şey olmuyordu.
  // Şimdi ürün kurulumu izole: bir bölümün hatası diğerini engellemez.
  // Galeri, urunKur'dan ÖNCE kurulur: urunKur'un ilk esitle() çağrısı
  // (?variant= ile gelen ziyaretçi) galeriye olay gönderir, dinleyici hazır olmalı.
  // Vitrin: sağ sütundaki açıklama videoları da ([data-sim-oynat]) aynı
  // kuralla oynar — ekrana girince sessiz döngü, dokununca dur/oynat.
  document.querySelectorAll('[data-sim-reels],[data-sim-oynat]').forEach(function (r) {
    try { reelsKur(r); } catch (e) {
      if (window.console && console.error) console.error('SİM reelsKur hatası:', e);
    }
  });
  document.querySelectorAll('[data-sim-galeri]').forEach(function (g) {
    try { galeriKur(g); } catch (e) {
      if (window.console && console.error) console.error('SİM galeriKur hatası:', e);
    }
  });
  document.querySelectorAll('[data-sim-urun]').forEach(function (kok) {
    try {
      urunKur(kok);
    } catch (e) {
      if (window.console && console.error) console.error('SİM urunKur hatası:', e);
    }
    try {
      adetKur(kok);
    } catch (e) {
      if (window.console && console.error) console.error('SİM adetKur hatası:', e);
    }
  });
})();
